const state = {
  twoYearsTrainingData: "",
  threeYearsModules: [
    {
      name: "Orientierungseinsatz beim TpA",
      totalHours: 400,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      isTrainingPlannedOption: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Pflichteinsatz Stationäre Akutpflege",
      totalHours: 400,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Pflichteinsatz Stationäre Langzeitpflege",
      totalHours: 400,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Pflichteinsatz Ambulante Akut-/Langzeitpflege",
      totalHours: 400,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Pflichteinsatz Pädiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Pflichteinsatz Psychiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",

        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Vertiefungseinsatz im Bereich eines Pflichteinsatzes beim TpA",
      totalHours: 500,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      isTrainingPlannedOption: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Wahleinsatz 1",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Wahleinsatz 2",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      isTrainingPlannedOption: true,
      isTrainingPlanned: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },

    {
      name: "Urlaub",
      totalHours: 0,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      vacationDays: [],
      trainingYear: 0,
      isTrainingPlannedOption: false,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
  ],

  twoYearsApModules: [
    {
      name: "Pflichteinsatz Stationäre Akutpflege",
      totalHours: 200,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Stationäre Langzeitpflege",
      totalHours: 270,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Ambulante Akut-/Langzeitpflege",
      totalHours: 270,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Pädiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Psychiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",

        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Vertiefungseinsatz im Bereich eines Pflichteinsatzes",
      totalHours: 500,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 1",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 2",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Urlaub",
      totalHours: 0,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      vacationDays: [],
      trainingYear: 0,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
  ],
  twoYearsLzpModules: [
    {
      name: "Pflichteinsatz Stationäre Akutpflege",
      totalHours: 300,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Stationäre Langzeitpflege",
      totalHours: 200,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Ambulante Akut-/Langzeitpflege",
      totalHours: 240,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Pädiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Psychiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",

        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Vertiefungseinsatz im Bereich eines Pflichteinsatzes",
      totalHours: 500,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 1",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 2",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Urlaub",
      totalHours: 0,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      vacationDays: [],
      trainingYear: 0,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
  ],
  twoYearsApLpModules: [
    {
      name: "Pflichteinsatz Stationäre Akutpflege",
      totalHours: 300,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Stationäre Langzeitpflege",
      totalHours: 240,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Ambulante Akut-/Langzeitpflege",
      totalHours: 200,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Pädiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 1,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Pflichteinsatz Psychiatrische Versorgung",
      totalHours: 120,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",

        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Vertiefungseinsatz im Bereich eines Pflichteinsatzes",
      totalHours: 500,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 1",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Wahleinsatz 2",
      totalHours: 80,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      trainingYear: 2,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
    {
      name: "Urlaub",
      totalHours: 0,
      plannedHours: 0,
      dayShiftRanges: [],
      nightShiftRanges: [],
      vacationDays: [],
      trainingYear: 0,
      trainingCompany: {
        name: "",
        contactPerson: "",
        contactPersonGender: "",
        street: "",
        houseNumber: "",
        postCode: "",
        place: "",
        telephone: "",
        email: "",
      },
    },
  ],
  currentModule: {
    name: "Orientierungseinsatz beim TpA",
    totalHours: 400,
    plannedHours: 0,
    dayShiftRanges: [],
    nightShiftRanges: [],
    trainingYear: 1,
    trainingCompany: {
      name: "",
      contactPerson: "",
      contactPersonGender: "",
      street: "",
      houseNumber: "",
      postCode: "",
      place: "",
      telephone: "",
      email: "",
    },
  },
  companyData: {
    name: "",
    contactPerson: "",
    contactPersonGender: "",
    street: "",
    houseNumber: "",
    postCode: "",
    place: "",
    telephone: "",
    email: "",
  },
  studentData: {
    lastname: "",
    firstname: "",
    class: "",
  },
  currentTrainingModules: [],
  currentSavedPlans: [],
  otherDurationSavedPlans: [],
  newPlanItem: { value: "Neuer Plan", name: "Neuer Plan" },
  savedPlansNames: [],
  currentSavedPlanName: null,
  numberOfPlannedModules: 0,
};

const getters = {
  getCurrentTrainingModules: (state) => state.currentTrainingModules,
  getCurrentModule: (state) => state.currentModule,
  getCompanyData: (state) => state.companyData,
  getStudentData: (state) => state.studentData,
  getCurrentSavedPlans: (state) => state.currentSavedPlans,
  getOtherDurationSavedPlans: (state) => state.otherDurationSavedPlans,
  getSavedPlansNames: (state) => state.savedPlansNames,
  getCurrentSavedPlanName: (state) => state.currentSavedPlanName,
  getNumberOfPlannedModules: (state) => state.numberOfPlannedModules,
};

const actions = {
  checkLocalStorage({ state }, duration) {
    // 1. Reset state
    state.savedPlansNames = [state.newPlanItem]; // Start with the "New Plan" item
    state.currentSavedPlans = [];
    state.otherDurationSavedPlans = [];

    const keys = Object.keys(localStorage);
    let i = keys.length;

    while (i--) {
      try {
        const item = JSON.parse(localStorage.getItem(keys[i]));

        // 2. CHECK: Is it an object? Is it not null? Does it have student.firstname?
        // Check 'plan.student' first because 'firstname' is nested inside state
        if (
          item &&
          typeof item === "object" &&
          item.student &&
          item.student.firstname
        ) {
          if (item.trainingDuration === duration) {
            state.currentSavedPlans.push(item);
            state.savedPlansNames.push({
              value: `${item.student.firstname} ${item.student.lastname}`,
              name: `${item.student.firstname} ${item.student.lastname}`,
            });
          } else {
            state.otherDurationSavedPlans.push(item);
          }
        }
      } catch (e) {
        // This catches items that aren't valid JSON (like plain strings)
        // console.warn(
        //   `Skipping key "${keys[i]}" as it is not a valid plan object.`
        // );
        console.log(e);
      }
    }

    state.currentSavedPlanName = state.savedPlansNames[0];
  },
};

const mutations = {
  setCurrentModule(state, index) {
    state.currentModule = JSON.parse(
      JSON.stringify(state.currentTrainingModules[index])
    );
  },

  setCompanyData(state, data) {
    if (data === null) {
      state.companyData.name = "";
      state.companyData.contactPerson = "";
      state.companyData.contactPersonGender = "";
      state.companyData.street = "";
      state.companyData.houseNumber = "";
      state.companyData.postCode = "";
      state.companyData.place = "";
      state.companyData.telephone = "";
      state.companyData.email = "";
    } else {
      state.companyData = data;

      // Assign the trainingCompany data to both modules when the user
      // enter changes the company data
      const modulesToAutoUpdate = state.currentTrainingModules.filter(
        (module) => {
          return (
            module.name ===
              "Vertiefungseinsatz im Bereich eines Pflichteinsatzes beim TpA" ||
            module.name === "Orientierungseinsatz beim TpA"
          );
        }
      );

      modulesToAutoUpdate.forEach((module) => {
        module.trainingCompany = JSON.parse(JSON.stringify(data));
        state.currentModule.trainingCompany = data;
      });
    }
  },

  setStudentData(state, data) {
    if (data === null) {
      state.studentData.lastname = "";
      state.studentData.firstname = "";
      state.studentData.class = "";
    } else {
      state.studentData = data;
    }
  },

  updateStateModule(state, payload) {
    const index = state.currentTrainingModules.findIndex(
      (element) => element.name === payload.name
    );

    state.currentTrainingModules[index] = payload;
  },

  setCurrentSavedPlanName(state, payload) {
    state.currentSavedPlanName = payload;
  },

  resetAllModulesPlannedHoures(state) {
    state.currentTrainingModules.forEach(async (trainingModule) => {
      trainingModule.dayShiftRanges = [];
      trainingModule.nightShiftRanges = [];
      trainingModule.plannedHours = 0;
      if (trainingModule.vacationDays !== undefined) {
        trainingModule.plannedHours = 1;
        trainingModule.vacationDays = [];
      }
    });
  },

  setCurrentTrainingModules(state, payload) {
    if (payload.trainingDuration === 3) {
      state.currentTrainingModules = JSON.parse(
        JSON.stringify(state.threeYearsModules)
      );
    } else {
      if (payload.item === "GPA AP") {
        state.currentTrainingModules = JSON.parse(
          JSON.stringify(state.twoYearsApModules)
        );
      } else if (payload.item === "GPA LZP") {
        state.currentTrainingModules = JSON.parse(
          JSON.stringify(state.twoYearsLzpModules)
        );
      } else {
        state.currentTrainingModules = JSON.parse(
          JSON.stringify(state.twoYearsApLpModules)
        );
      }
    }
    state.currentModule = JSON.parse(
      JSON.stringify(state.currentTrainingModules[0])
    );
  },

  setCurrentTrainingModulesFromSavedPlan(state, payload) {
    state.currentTrainingModules = [...payload.trainingModules];

    //TODO Remove this condition app-version 10 ====>
    // Check saved plan if it does not have the switch values and add them to it in
    // order to avoid errors
    if (
      payload.trainingDuration === 3 &&
      state.currentTrainingModules[0].isTrainingPlannedOption === undefined
    ) {
      state.currentTrainingModules.forEach((trainingModule) => {
        if (
          trainingModule.name ===
            "Vertiefungseinsatz im Bereich eines Pflichteinsatzes beim TpA" ||
          trainingModule.name === "Orientierungseinsatz beim TpA" ||
          trainingModule.name === "Urlaub"
        ) {
          trainingModule.isTrainingPlannedOption = false;
        } else {
          (trainingModule.isTrainingPlannedOption = true),
            (trainingModule.isTrainingPlanned = false);
        }
      });
    }
    //TODO Remove this condition app-version 10 <====
  },

  removeSavedPlan(state, planToRemove) {
    localStorage.removeItem(
      `${planToRemove.firstname} ${planToRemove.lastname}`
    );

    if (state.currentSavedPlans.indexOf(planToRemove) > -1) {
      state.currentSavedPlans.splice(
        state.otherDurationSavedPlans.indexOf(planToRemove, 1)
      );
    }

    if (state.otherDurationSavedPlans.indexOf(planToRemove) > -1) {
      state.otherDurationSavedPlans.splice(
        state.otherDurationSavedPlans.indexOf(planToRemove, 1)
      );
    }

    let foundStudentToDelete = state.savedPlansNames.find((student) => {
      student.name ===
        `${planToRemove.student.firstname} ${planToRemove.student.lastname}`;
    });

    if (state.savedPlansNames.indexOf(foundStudentToDelete, 1) !== -1) {
      state.savedPlansNames.splice(
        state.savedPlansNames.indexOf(foundStudentToDelete, 1)
      );
    }
  },

  setNumberOfPlannedModules(state, number) {
    state.numberOfPlannedModules = number;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
